import axios from "axios";

export default async function addProjectUser(projectName, user) {
    await axios.patch(`/project/${projectName}/new-user`, {
        "username": user
    })
}